<template>
    <div>
        <div class="form-horizontal">
            <form-input :form="form" property="name"></form-input>
            <form-input :form="form" property="email"></form-input>
            <form-input :form="form" property="password">
                <input type="password" v-model="form.password" class="form-control">
            </form-input>
            <form-input :form="form" property="groups">
                <select3 data-url="/api/groups" v-model="form.groups" multiple />
            </form-input>

            <form-input :form="form" property="team_id">
                <select3 :value="form.teams" @input="changeTeam"  :value-key="`name`" data-url="/api/teams" allow-clear></select3>
            </form-input>
            <!--<form-input :form="form" property="teams">-->
                <!--<select3 data-url="/api/teams" v-model="form.teams" @input="form.team_id = $event.id; form.teams = $event"/>-->
            <!--</form-input>-->
            <!--<form-input :form="form" property="team_id">-->
                <!--<select3 :value="form.teams"  data-url="/api/teams" @input="form.team_id = $event.id; form.teams = $event"></select3>-->
            <!--</form-input>-->
        </div>
        <activity-log v-if="exists" :api="`/api/users/${form.id}/activity`" ref="activityLog"></activity-log>
    </div>
</template>


<script>
import Model from 'lib/Model';
import Form from 'lib/Form';

export default {
    mixins: [Model],
    data() {
        return {
            method: '/api/users',
            form: new Form(() => {
                return {
                    //                    team_id: null,
                    team_id: null,
                    teams: null,
                    name: '',
                    email: '',
                    password: '',
                    groups: [],
                };
            })
        };
    },
    methods:{
        changeTeam(team)
        {
          	this.form.team_id = team && team.id;
          	this.form.team = team;
        }
    },
    mounted() {
        this.$on('input', () => {
            if (this.$refs.activityLog) {
                this.$refs.activityLog.load();
            }
        });
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/forms/User.vue